import { HTTPv2, Service } from '@/services/config'
import { IDisableInspectionPhotoParams, IReproveInspectionPhotoParams, IUpdateInspectionPhotoObservation } from '@/types/inspection.types'

class InspectionPhotoServiceV2 extends Service {
  path = 'vistoriafoto'

  constructor() {
    super(HTTPv2)
  }

  async getPhotoParametrization(id: any) {
    const httpResponse = await this.httpClient.get(`/${this.path}/listar-fluxo-fotos/${id}`)
    return httpResponse
  }

  async getUrlUpload(imagePaths: string[]) {
    const httpResponse = await this.httpClient.post(`/${this.path}/gerar-upload-urls`, {
      objectPath: imagePaths,
    })
    return httpResponse
  }

  async uploadPhoto(uploadUrl: string, file: File, contentType = 'image/jpeg') {
    const response = await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type ?? contentType,
      },
    })

    if (!response.ok) {
      throw new Error(`Upload falhou: ${response.statusText}`)
    }
    return response
  }

  async post(params: any) {
    const httpResponse = await this.httpClient.post(`/${this.path}`, params)
    return httpResponse
  }

  async disable(params: IDisableInspectionPhotoParams) {
    const httpResponse = await this.httpClient.patch(`${this.path}/desativar`, params)
    return httpResponse
  }

  async reprove(params: IReproveInspectionPhotoParams) {
    const httpResponse = await this.httpClient.put(`${this.path}/reprovar-fotos`, params)
    return httpResponse
  }

  async updateObservation(params: IUpdateInspectionPhotoObservation) {
    const httpResponse = await this.httpClient.put(`${this.path}/atualizar-observacao`, params)
    return httpResponse
  }
}

export const inspectionPhotoServiceV2 = new InspectionPhotoServiceV2()
